import Link from 'next/link'
import styled from 'styled-components'

import { useGetRafflesQuery } from 'api/rafflesApi'
import ExpandedMenuModal from 'layout/navigation/components/ExpandedMenuModal'
import HoverIntent from 'layout/navigation/components/HoverIntent'
import { MenuLink } from 'layout/navigation/components/MenuLink'
import { t } from 'localization'
import { headerNavigationTrackEvent } from 'mParticle/headerNavigationTrackEvent'
import { HeaderQA } from 'shared/dataAttributes'

const TP = 'layout.navigation.StoresMenu'

interface IStoresMenuProps {
  isOpen: boolean
  closeMenu: () => void
}

export const StoresMenu = ({ isOpen, closeMenu }: IStoresMenuProps) => {
  const { data: raffles } = useGetRafflesQuery(undefined, {
    skip: !isOpen,
  })
  const displayRaffles =
    raffles?.filter((r) => r.status === 'active' || r.status === 'upcoming') ?? []

  return (
    <ExpandedMenuModal
      isOpen={isOpen}
      contentLabel={t(`${TP}.storesMenu`, 'Stores Menu')}
      onRequestClose={closeMenu}
      qaAttr={HeaderQA.NavigationStoresMenu}
    >
      <HoverIntent onExit={closeMenu}>
        <MenuContainer>
          <Link href="/storelocator" passHref legacyBehavior>
            <MenuLink onClick={(e) => headerNavigationTrackEvent(e)}>
              {t(`${TP}.allStores`, 'All Stores')}
            </MenuLink>
          </Link>
          {displayRaffles.map((raffle) => (
            <Link key={raffle.slug} href={`/drawings/${raffle.slug}`} passHref legacyBehavior>
              <MenuLink
                onClick={(e) => headerNavigationTrackEvent(e)}
                data-qa={HeaderQA.StoresNavRaffleLink}
              >
                {raffle.productName} {t(`${TP}.raffle`, 'Drawing')}
              </MenuLink>
            </Link>
          ))}
        </MenuContainer>
      </HoverIntent>
    </ExpandedMenuModal>
  )
}

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;

  ${MenuLink} {
    text-align: right;
  }
`
